import { useSWRConfig } from 'swr'
import { useFetch } from '@/hooks/useFetch'
import { fetcher } from '@/lib/fetcher'
import type { Sku as SKUAPI } from '@/pages/api/[account]/search/offers/ProductOffer'

interface UseUpdateSkuProps {
  onSuccess: () => void
  onError: (errorMessage?: string) => void
}

export const useUpdateSku = (props: UseUpdateSkuProps) => {
  const { onSuccess, onError } = props

  const { mutate } = useSWRConfig()

  return async (sku: Partial<SKUAPI>, productId: string) => {
    try {
      await fetcher({
        url: `/api/sku/${sku.SkuId}`,
        body: JSON.stringify(sku),
        method: 'PUT',
      })

      onSuccess?.()

      mutate(
        (key: Record<string, string>) =>
          typeof key === 'object' &&
          (key.url?.startsWith(
            `/api/proxy/catalog/pvt/admin/product/${productId}/skus`
          ) ||
            key.url?.startsWith(`/api/products`)),
        undefined,
        {
          revalidate: true,
        }
      )

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      onError?.(error?.response?.data?.error)
    }
  }
}

type Price = {
  sellingPrice: number
}

export const useSKUPrice = (skuId: number, salesChannel: string = '1') =>
  useFetch<Price>(
    ({ account }) =>
      `/api/proxy/vtex/${account}/pricing/prices/${skuId}/computed/${salesChannel}`,
    {
      statusCodesToBeIgnoreByLogger: [404],
    }
  )
